import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { ja } from 'vuetify/locale'

export default createVuetify({
  components,
  directives,

  locale: {
    locale: 'ja',
    fallback: 'en',
    messages: { ja },
  },

  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#EE6090',
          secondary: '#5D6B70',
          accent: '#8c9eff',
          error: '#FF3F3A',
          lighten1: '#FFE1E0',
        },
      },
    },
  },
})
